/* eslint-disable-next-line */
import "@babel/polyfill";
import Vue from "vue";

// App
import App from "./FileManager.vue";

Vue.config.productionTip = process.env.NODE_ENV === "production";

window.fm = new Vue({
	render: h => h(App)
}).$mount("#fm");
